export enum PayorInvoiceBatchReviewStatus {
  PendingReview = 1,
  Released = 2,
  Issue = 3,
}
